<template>
  <div class="entryApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    
    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
        <span @click="toPush(setDetail.id,'role')">超级管理员<img src="~assets/images/icon5.png"></i></span>
      </div>
    </div>
    
    <div class="parkData">
      <h2>
        <div>入园数据统计</div>
        <div class="amounts">
          <span>{{total}}  <font>({{years}}年数据)</font></span>
          <div class="tab">
            <a :class="years == 2026 ? 'curt' : ''" @click="parksClick(2026)">2026年</a>
            <a :class="years == 2025 ? 'curt' : ''" @click="parksClick(2025)">2025年</a>
            <a :class="years == 2024 ? 'curt' : ''" @click="parksClick(2024)">2024年</a>
            <a :class="years == 2023 ? 'curt' : ''" @click="parksClick(2023)">2023年</a>
          </div>
        </div>
      </h2>
      <div id="park" style="height:180px;margin-top:30px"></div>
    </div>

    <div class="parkData">
      <h2>
        <div>入园会员信息</div>
        <div class="amounts">
          <span>{{setData.total}} <font>({{ys}}年数据)</font></span>
          <div class="tab">
            <a :class="ys == 2026 ? 'curt' : ''" @click="parksClick1(2026)">2026年</a>
            <a :class="ys == 2025 ? 'curt' : ''" @click="parksClick1(2025)">2025年</a>
            <a :class="ys == 2024 ? 'curt' : ''" @click="parksClick1(2024)">2024年</a>
            <a :class="ys == 2023 ? 'curt' : ''" @click="parksClick1(2023)">2023年</a>
          </div>
        </div>
      </h2>
      <ul>
        <li v-for="(item,i) in setData.rs">
          <div :class="item.isvip == 1 ? 'isuservip':''">
            <img :src="item.avatar" />
            <div class="info">
              <div class="A1">
                <span>{{item.username}}</span>
                <span>{{item.createtime}}</span>
              </div>
              <div class="A2">手机号:{{item.phone}}</div>
              <div class="A2">身份证号:{{item.idCard}}</div>
              <div v-if="setData.istoo == 1" class="A2" style="color:green;font-weight:bold">订单编号:{{item.number}}</div>
              <div v-if="setData.istoo == 1" class="A2" style="color:green;font-weight:bold">支付金额: {{item.price}}元</div>
            </div>
            <font v-if="item.isvip == 1">VIP</font>
          </div>
        </li>
        
      </ul>
    </div>

    <div style="height:15px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setDetail:[],
        years:2026,
        total:0,
        setData:[],
        ys:2026,
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getPark();
      this.ryUser()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      parksClick:function(d){
        this.years = d;
        this.getPark();
      },
      getPark:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/yearPark',
          params:{
            id:id,
            years:that.years
          }
        }).then(function(response){
          var res = response.data.data;
          that.total = res.total;
          that.park(res)
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      park:function(msg){
        var myChart = this.$echarts.init(document.getElementById('park'));
        var option;
        option = {
          color:['#67AEFF'],
          grid: {
            left:20,
            right:30,
            top:20,
            bottom:0,
            containLabel: true
          },
            xAxis: {
              type: 'category',
              data: msg.day,
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(255,255,255,0)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'value',
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            },
            series: [{
              data: msg.nums,
              type: 'line',
              smooth: true,
              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: "#67AEFF" // 0% 处的颜色
                    }, {
                      offset:1,
                      color: "rgba(103,174,255,0)" // 100% 处的颜色
                    }],
                      globalCoord: false // 缺省为 false
                  }
                }
              },
              itemStyle : { normal: {label : {show: true}}},
            }]
        };

        option && myChart.setOption(option);
      },

      parksClick1:function(d){
        this.ys = d;
        this.ryUser();
      },
      ryUser:function(){
        var id = this.$route.query.id
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/index/useCardData',
          params:{
            id:id,
            years:that.ys
          }
        }).then(function(response){
          that.setData = response.data.data;
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .entryApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .entryApp .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .entryApp .scenicList img{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .entryApp .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .entryApp .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .entryApp .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .entryApp .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .entryApp .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .entryApp .scenicList .level span{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:2px
  }
  .entryApp  .scenicList .level span img{
    float:right;
    width:6px;
    margin:2px 0 0 8px
  }

  .entryApp .parkData{
    width:92%;
    margin:15px auto 0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    padding-bottom:20px
  }

  .entryApp .parkData h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0 0;
    border-bottom:solid 1px #fafafa
  }
  .entryApp .parkData h2 i{
    float:right;
    font-size:14px;
    font-style: normal;
    font-weight:normal;
    color:#999
  }
  .entryApp .parkData h2 i img{
    width:6px;
    margin-left:5px
  }
  .entryApp .parkData h2 .amounts{
    padding:15px 0 7px 0;
  }
  .entryApp .parkData h2 .amounts span{
    font-size:22px
  }
  .entryApp .parkData h2 .amounts font{
    font-size:12px;
    color:#999;
    font-weight:normal;
    position: relative;
    top:-2px;
  }
  .entryApp .parkData h2 .amounts .tab{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:8px
  }
  .entryApp .parkData h2 .amounts .tab a{
    font-size:12px;
    color:#666;
    margin-left:15px;
    font-weight:normal;
    position: relative;
  }
  .entryApp .parkData h2 .amounts .tab a.curt:after{
    position: absolute;
    content: '';
    background: #333;
    width:15px;
    height: 2px;
    border-radius: 2px;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
  }

  .entryApp .parkData li:last-child{
    border-bottom:none;
  }
  .entryApp .parkData li{
    border-bottom:solid 1px #EBF2FF;
    width:92%;
    margin:0 auto;
  }
  .entryApp .parkData li img{
    float:left;
    width:70px;
    height:70px;
    margin:15px 5px 10px 0px;
    border-radius:50%;
  }
  .entryApp .parkData li:after,.entryApp .parkData li .isuservip:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .entryApp .parkData li .info{
    float:left;
    width:75%;
    margin-top:10px
  }
  .entryApp .parkData li .info .A1{
    font-size:15px;
    padding-bottom:7px;
    height:20px
  }
  .entryApp .parkData li .info .A1 span:last-child{
    font-size:14px;
    float:right;
    color:#555;
    margin-top:3px
  }

  .entryApp .parkData li .info .A1 span:first-child{
    float:left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width:45%
  }
  .entryApp .parkData li .info .A2{
    font-size:14px;
    padding-bottom:5px;
    color:#999;
  }

  .entryApp .parkData li .isuservip{
    border:2px dashed #ffd700;
    margin:15px 0;
    border-radius:6px;
    position:relative;
    float:left;
    width:98%;
    padding-left:2%
  }
  .entryApp .parkData li .isuservip font{
    position:absolute;
    top:-10px;
    right:-10px;
    color:#f00;
    font-weight:bold;
    border:2px dashed #ffd700;
    border-radius: 50%;
    width:23px;
    height:23px;
    background:#fff;
    font-size:12px;
    line-height:23px;
    text-align:center
  }
</style>